module.exports = __webpack_public_path__ + "img/u977.4321a088.svg";